class ProductForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("variant:changed", (e) => {
      const { variant, variantData } = e.detail;

      this._updateAtcs(variant);
      this._updatePrices(variant);
      this._updateUrl(variant);
      this._updateSizeInputs(variant);
      this._updateSelectedSizes(variant);
      this._updateBackInStocks(variant);
      this._updateLowStocks(variant, variantData);
    });
  }

  get atcs() {
    return this.querySelectorAll("[data-product-form-atc]");
  }

  get prices() {
    return this.querySelectorAll("price-snippet");
  }

  get sizeInputs() {
    return this.querySelectorAll('input[name="id"]');
  }

  get selectedSizes() {
    return this.querySelectorAll("[data-selected-size]");
  }

  get backInStocks() {
    return this.querySelectorAll("back-in-stock-button");
  }

  get lowStocks() {
    return this.querySelectorAll("product-low-stock");
  }

  get updateUrl() {
    return !this.hasAttribute("disable-update-url");
  }

  get bisForm() {
    return this.querySelector("data-bis-modal-content");
  }

  _updateAtcs(variant) {
    this.atcs.forEach((atc) => {
      atc.disabled = !variant.available;
    });
  }

  _updatePrices(variant) {
    this.prices.forEach((price) => {
      price.setAttribute("price", variant.price / 100);
      price.setAttribute("compare-at-price", variant.compare_at_price / 100);
      price.setAttribute("currency", window.Shopify.currency.active);
      price.setAttribute("dynamic", "");
    });
  }

  _updateSizeInputs(variant) {
    this.sizeInputs.forEach((sizeInput) => {
      if (parseInt(sizeInput.value, 10) === variant.id) {
        sizeInput.checked = true;
      }
    });
  }

  _updateSelectedSizes(variant) {
    this.selectedSizes.forEach((selectedSize) => {
      selectedSize.classList.toggle(
        "product-form__size--sold-out",
        variant.availableForSale,
      );
      selectedSize.innerHTML = variant.option1;
    });
  }

  _updateBackInStocks(variant) {
    this.backInStocks.forEach((backInStock) => {
      backInStock.setAttribute("selected-variant", variant.id);
    });
  }

  _updateLowStocks(variant, variantData) {
    this.lowStocks.forEach((lowStock) => {
      lowStock.setAttribute(
        "inventory-quantity",
        variantData.inventory_quantity,
      );
      lowStock.setAttribute(
        "inventory-management",
        variant.inventory_management,
      );
    });
  }

  _updateUrl(variant) {
    const url = new URL(window.location);

    if (!window.Shopify.designMode && this.updateUrl) {
      url.searchParams.set("variant", variant.id);
      window.history.pushState("", "", url);
    }
  }
}

if (!customElements.get("product-form")) {
  customElements.define("product-form", ProductForm);
}
